export function OutlineImageIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5348 18.3008C20.17 18.728 19.6228 19.0016 19.018 19.0016H10.0132L11.7268 16.5056L15.514 11L20.5348 18.3008Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7266 16.506L10.013 19.002H5.01137C4.44977 19.002 3.94097 18.7668 3.57617 18.3924L8.51537 13.002L11.7266 16.506Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0146 6.9968V17.0048C21.0146 17.4992 20.8322 17.9504 20.5346 18.3008L15.5138 11L11.7266 16.5056L8.51545 13.0016L3.57625 18.392C3.23065 18.0368 3.01465 17.5472 3.01465 17.0048V6.9968C3.01465 5.8976 3.90745 5 5.01145 5H19.0178C20.117 5 21.0146 5.8976 21.0146 6.9968Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
